<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="9" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorField('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Price -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Preço</label>
        <d-input-group prepend="R$">
          <input-currency
            :state="hasErrorField('price')"
            model-index="price"
            placeholder="Total"
            :model="model"
          ></input-currency>
        </d-input-group>
        <d-form-invalid-feedback>Preço é obrigatório</d-form-invalid-feedback>
      </d-col>

    </d-form-row>

    <d-form-row v-if="model.id">
      <!-- Equipment -->
      <d-col md="12" class="form-group">
        <equipments
          :model.sync="model"
          :load-event="loadEquipment"
          :reload-event="reloadEquipment"
          :delete-event="deleteEquipment"
        />
      </d-col>
    </d-form-row>
    <add-equipment-modal
      :load-event="loadEquipment"
      :save-event="SAVE_EQUIPMENT_REQUEST_SERVICE"
      :reload-event="reloadEquipment"
      :search-event="SEARCH_EQUIPMENTS_SERVICE"
      :equipments-list="equipments"
    />
  </d-form>

</template>

<script>
import { mapActions } from 'vuex';
import { stringfy } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import Events from '_utils/events';
import InputCurrency from '_shared/InputCurrency.vue';
import Equipments from '_shared/Equipments.vue';
import AddEquipmentModal from '_shared/AddEquipmentModal.vue';
import ProductService from '_services/rest/modules/product';
import {
  MODEL,
  SAVE_EQUIPMENT_REQUEST_SERVICE,
  SEARCH_EQUIPMENTS_SERVICE,
  _DELETE_PRODUCT_EQUIPMENT_SERVICE_,
  _LOAD_EQUIPMENT_SERVICE_,
  _LOAD_MODEL_,
  _RELOAD_EQUIPMENT_SERVICE_,
  _SAVE_SERVICE_SUCCESS_,
} from './ServiceModel';

export default {
  name: 'service-form',
  mixins: [mixin, formatErrors],
  components: {
    InputCurrency,
    Equipments,
    AddEquipmentModal,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
        price: { required: false },
      },
      loadEquipment: _LOAD_EQUIPMENT_SERVICE_,
      reloadEquipment: _RELOAD_EQUIPMENT_SERVICE_,
      deleteEquipment: _DELETE_PRODUCT_EQUIPMENT_SERVICE_,
      SAVE_EQUIPMENT_REQUEST_SERVICE,
      SEARCH_EQUIPMENTS_SERVICE,
    };
  },
  computed: {
    equipments() {
      const { equipments } = this.$store.state.service;
      if (equipments && equipments.length) {
        return equipments;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'setService',
      'activeAlert',
      'getEquipments',
    ]),
    addNewType() {
      this.setToggle({ type: 'add_type_option_modal', bool: true });
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        ProductService.saveEntity(this.model, 'service')
          .then(response => {
            this.success(response);
          })
          .catch(this.showError);
      }
      return null;
    },
    success(serviceSaved) {
      this.activeAlert({
        message: 'Serviço salvo com sucesso',
        theme: 'success',
      });
      this.setService(serviceSaved);
      Events.$emit(_SAVE_SERVICE_SUCCESS_, serviceSaved);
    },
    async handleSaveEquipment({ entityId, model }) {
      try {
        const response = await ProductService.saveEquipment(entityId, model);
        Events.$emit(_RELOAD_EQUIPMENT_SERVICE_, response);
        this.setToggle({ type: 'add_equipment_modal', bool: false });
      } catch (error) {
        this.activeAlert({
          message: `${error.message} <br/> ${error.data}`,
          theme: 'danger',
        });
      }
    },
    handleSearchEquipments(query) {
      this.getEquipments(query);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });

    Events.$on(this.SAVE_EQUIPMENT_REQUEST_SERVICE, this.handleSaveEquipment);
    Events.$on(this.SEARCH_EQUIPMENTS_SERVICE, this.handleSearchEquipments);
  },
  beforeDestroy() {
    Events.$off(this.SAVE_EQUIPMENT_REQUEST_SERVICE, this.handleSaveEquipment);
    Events.$off(this.SEARCH_EQUIPMENTS_SERVICE, this.handleSearchEquipments);
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
}
</style>
